<template>
  <div class="static">
    <div ref="element" v-cleaned="field.values" class="content" />
  </div>
</template>
<script setup lang="ts">
interface Props {
  field: FormField;
}
defineProps({
  field: null
});

const element = ref<HTMLElement>(null);

const emit = defineEmits(["loading"]);

useHtmlLoading(element, emit);
</script>
<style lang="scss" scoped>
.static {
  display: flex;
  justify-content: center;

  .content {
    max-width: 50rem;
    text-align: center;
  }
}
</style>
